module.exports = __webpack_public_path__ + "img/arrow-right-circle-fill.650fa4cc.svg";